// /* eslint-disable no-unused-vars */
// import { Formik } from 'formik';
// import { useEffect } from 'react';
// import { Forms, LoginSection } from './AuthStyles';
// import * as Yup from 'yup';
// import { Spinner, Text, Box } from '@chakra-ui/react';
// import { Link, useNavigate } from 'react-router-dom';
// import { ReactComponent as Facebook } from '../../assets/facebook.svg';
// import { ReactComponent as Google } from '../../assets/google.svg';
// import GoogleLoginButton from './GoogleLoginButton';
// import { useDispatch, useSelector } from 'react-redux';
// import { userLogin } from '../../redux/actions/authActions';
// import InputText from 'components/Input';
// import Loader from 'components/loader';

// const LoginForm = ({ screen }) => {
//     const validationSchema = Yup.object().shape({
//         user_identification: Yup.string().required('An email address is required'),
//     });

//     const initialValues = { user_identification: '', password: '' };
//     let navigate = useNavigate();
//     const dispatch = useDispatch();
//     const authReducer = useSelector((state) => state.authReducer);
//     const { user, loading } = authReducer;

//     useEffect(() => {
//         if (user) {
//             // dispatch(clearReq());
//             navigate('/login-verify');
//         }
//     }, [user, navigate]);

//     if (loading) {
//         return (
//             <LoginSection>
//                 <Forms>
//                     <Loader />
//                 </Forms>
//             </LoginSection>
//         );
//     }

//     return (
//         <LoginSection>
//             <Formik
//                 enableReinitialize
//                 initialValues={initialValues}
//                 validationSchema={validationSchema}
//                 // onSubmit={onSubmit}
//                 onSubmit={async (values, { setSubmitting }) => {
//                     // setSubmitting(true);
//                     let data = { ...values, platform: 'agent' };
//                     dispatch(userLogin(data));
//                     // setSubmitting(false);
//                 }}>
//                 {({
//                     values,
//                     errors,
//                     touched,
//                     handleChange,
//                     handleBlur,
//                     handleSubmit,
//                     isSubmitting,
//                     setFieldValue,
//                     setFieldTouched,
//                 }) => (
//                     <Forms onSubmit={handleSubmit}>
//                         <section className="top-login">
//                             {screen > 500 && (
//                                 <div className="title">
//                                     <h3>Login</h3>
//                                 </div>
//                             )}{' '}
//                             <div className="border-group">
//                                 <label className="input-label" htmlFor="email">
//                                     Email address
//                                 </label>
//                                 <div className="form-group">
//                                     <input
//                                         type="text"
//                                         name="user_identification"
//                                         onChange={handleChange}
//                                         onBlur={handleBlur}
//                                         value={values.user_identification}
//                                         inputMode="email"
//                                         placeholder="my.email@address.com"
//                                     />
//                                 </div>
//                                 <div className="error-message">
//                                     {touched.user_identification && errors.user_identification}
//                                 </div>
//                                 <label className="input-label" htmlFor="email">
//                                     Password
//                                 </label>
//                                 <InputText
//                                     type="password"
//                                     placeholder="Password"
//                                     name="password"
//                                     onChange={handleChange}
//                                     value={values.password}
//                                     onBlur={handleBlur}
//                                 />
//                                 <div className="error-message">
//                                     {touched.password && errors.password}
//                                 </div>
//                                 <div className="forgot-link">
//                                     <Link to="/forgot-password" className="forgot">
//                                         Forgot Password?
//                                     </Link>
//                                 </div>
//                                 <section className="bottom-login">
//                                     {screen <= 500 && (
//                                         <p>
//                                             By continuing, you agree to our{' '}
//                                             <Link to="/">Terms of Service</Link> and{' '}
//                                             <Link to="/">Privacy Policy.</Link>
//                                         </p>
//                                     )}
//                                     <button type="submit" className="" disabled={loading}>
//                                         {!loading ? 'Log in' : <Spinner color="white" size="sm" />}
//                                     </button>
//                                     <div className="forgot-link">
//                                         <Link to="/register">
//                                             <Text
//                                                 fontWeight={700}
//                                                 fontSize="18px"
//                                                 lineHeight="16px"
//                                                 mt="4"
//                                                 textDecoration={'underline'}
//                                                 className="forgot">
//                                                 No Account? Sign Up
//                                             </Text>
//                                         </Link>
//                                     </div>
//                                 </section>{' '}
//                             </div>
//                             {screen > 500 && (
//                                 <section className="bottom-login" style={{ marginTop: '1px' }}>
//                                     <p>
//                                         By continuing, you agree to our{' '}
//                                         <Link to="/">Terms of Service</Link> and{' '}
//                                         <Link to="/">Privacy Policy.</Link>
//                                     </p>
//                                 </section>
//                             )}
//                             {screen > 500 && (
//                                 <div className="socials">
//                                     <p className="socials-divider">or</p>
//                                     <div className="socials-buttons">
//                                         <GoogleLoginButton />
//                                     </div>
//                                 </div>
//                             )}
//                             {screen <= 500 && (
//                                 <div className="socials">
//                                     <p className="socials-divider">OR</p>
//                                     <div className="socials-buttons">
//                                         <GoogleLoginButton />
//                                     </div>
//                                 </div>
//                             )}
//                         </section>
//                     </Forms>
//                 )}
//             </Formik>
//         </LoginSection>
//     );
// };

// export default LoginForm;

import { useEffect, useState, useRef, useCallback, memo } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Box, Flex, Text, Spinner, Input, InputGroup, InputRightElement, IconButton } from '@chakra-ui/react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userLogin } from '../../redux/actions/authActions';
import GoogleLoginButton from './GoogleLoginButton';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */

const NAVY      = '#1B3B5F';
const NAVY_DEEP = '#0F2940';
const CYAN      = '#DCF8F9';
const INK       = '#1A2740';
const MUTED     = '#5A6B7E';
const FAINT     = '#8896AE';
const SURFACE   = '#FFFFFF';
const BORDER    = '#E8EDF5';
const DANGER    = '#E53E3E';

const FONT = "'Bricolage Grotesque', sans-serif";

/* ─────────────────────────────────────────────────────────────
   VALIDATION
   ───────────────────────────────────────────────────────────── */

const validationSchema = Yup.object().shape({
    user_identification: Yup.string()
        .trim()
        .email('Please enter a valid email address')
        .required('Email address is required'),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .required('Password is required'),
});

const INITIAL_VALUES = { user_identification: '', password: '' };

const routeAuthError = (rawError) => {
    const message =
        (typeof rawError === 'string' && rawError) ||
        rawError?.message ||
        rawError?.data?.message ||
        rawError?.response?.data?.message ||
        'Login failed. Please check your credentials and try again.';

    const lower = message.toLowerCase();

    if (
        lower.includes('email') ||
        lower.includes('user not found') ||
        lower.includes('account not found') ||
        lower.includes('no user') ||
        lower.includes('user does not exist') ||
        lower.includes('not registered')
    ) {
        return { field: 'email', message };
    }

    return { field: 'password', message };
};

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */

const EyeIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"
            stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
    </svg>
);

const EyeOffIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M2 2l20 20M6.7 6.7C4.1 8.3 2 12 2 12s3.5 7 10 7c2.1 0 3.9-.6 5.4-1.4M9.9 5.1C10.6 5 11.3 5 12 5c6.5 0 10 7 10 7-.6 1.1-1.6 2.5-3 3.7M9.9 9.9a3 3 0 004.2 4.2"
            stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
        />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   FIELD PRIMITIVES
   ───────────────────────────────────────────────────────────── */

const FieldLabel = memo(function FieldLabel({ children, htmlFor }) {
    return (
        <Text
            as="label"
            htmlFor={htmlFor}
            display="block"
            fontSize={{ base: '13px', md: '11px' }}
            fontWeight="600"
            color={INK}
            mb="4px"
            fontFamily={FONT}
        >
            {children}
        </Text>
    );
});

const FieldError = memo(function FieldError({ id, children }) {
    if (!children) return null;
    return (
        <Text
            id={id}
            fontSize={{ base: '12px', md: '10.5px' }}
            color={DANGER}
            mt="3px"
            fontFamily={FONT}
            role="alert"
        >
            {children}
        </Text>
    );
});

const FieldWrap = memo(function FieldWrap({ children, ...rest }) {
    return <Box mb="10px" {...rest}>{children}</Box>;
});

const baseInputStyles = {
    h:            { base: '42px', md: '38px' },
    fontSize:     { base: '16px', md: '12.5px' },
    color:        INK,
    bg:           SURFACE,
    border:       '1px solid',
    borderColor:  BORDER,
    borderRadius: '8px',
    px:           '10px',
    fontFamily:   FONT,
    _placeholder: { color: FAINT, fontSize: { base: '14px', md: '12px' } },
    _hover:       { borderColor: '#CBD5E0' },
    _focus:       {
        borderColor: NAVY,
        boxShadow:   `0 0 0 3px ${CYAN}`,
        bg:          SURFACE,
        outline:     'none',
    },
    _disabled:    { opacity: 0.6, cursor: 'not-allowed' },
};

const errorInputStyles = {
    borderColor: DANGER,
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    _focus: {
        borderColor: DANGER,
        boxShadow:   `0 0 0 3px ${DANGER}22`,
        outline:     'none',
    },
};

const OrDivider = memo(function OrDivider() {
    return (
        <Flex align="center" my="12px" gap="10px">
            <Box flex="1" h="1px" bg={BORDER} />
            <Text fontSize="9.5px" color={FAINT} fontWeight="700" letterSpacing="0.16em">
                OR
            </Text>
            <Box flex="1" h="1px" bg={BORDER} />
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   MAIN
   ───────────────────────────────────────────────────────────── */

const LoginForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = useState(false);
    const [authError, setAuthError] = useState(null);
    const submittedRef = useRef(false);

    const { user, error: reduxError, loading } = useSelector((s) => s.authReducer);
    const lastHandledErrorRef = useRef(null);

    useEffect(() => {
        if (!reduxError) return;
        if (!submittedRef.current) return;
        if (lastHandledErrorRef.current === reduxError) return;
        lastHandledErrorRef.current = reduxError;
        setAuthError(routeAuthError(reduxError));
    }, [reduxError]);

    useEffect(() => {
        if (user) navigate('/login-verify');
    }, [user, navigate]);

    const togglePassword = useCallback(() => setShowPassword((s) => !s), []);

    const handleSubmit = useCallback(
        async (values, { setSubmitting }) => {
            submittedRef.current = true;
            setAuthError(null);
            lastHandledErrorRef.current = null;
            try {
                const payload = {
                    user_identification: values.user_identification.trim(),
                    password: values.password,
                    platform: 'agent',
                };
                await dispatch(userLogin(payload));
            } catch (err) {
                setAuthError(routeAuthError(err));
            } finally {
                setSubmitting(false);
            }
        },
        [dispatch]
    );

    return (
        <Formik
            initialValues={INITIAL_VALUES}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnBlur
            validateOnChange={false}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit: onSubmit,
                isSubmitting,
            }) => {
                const emailFieldError =
                    (authError?.field === 'email' && authError.message) ||
                    (touched.user_identification && errors.user_identification) ||
                    null;

                const passwordFieldError =
                    (authError?.field === 'password' && authError.message) ||
                    (touched.password && errors.password) ||
                    null;

                const isBusy = loading || isSubmitting;

                const handleFieldChange = (e) => {
                    if (authError) {
                        const name = e.target.name;
                        const sameField =
                            (name === 'user_identification' && authError.field === 'email') ||
                            (name === 'password' && authError.field === 'password');
                        if (sameField) setAuthError(null);
                    }
                    handleChange(e);
                };

                return (
                    <form onSubmit={onSubmit} noValidate aria-labelledby="login-heading">
                        <FieldWrap>
                            <FieldLabel htmlFor="user_identification">Email address</FieldLabel>
                            <Input
                                id="user_identification"
                                name="user_identification"
                                type="email"
                                inputMode="email"
                                autoComplete="email"
                                placeholder="you@example.com"
                                value={values.user_identification}
                                onChange={handleFieldChange}
                                onBlur={handleBlur}
                                disabled={isBusy}
                                aria-invalid={!!emailFieldError}
                                aria-describedby={emailFieldError ? 'email-error' : undefined}
                                {...baseInputStyles}
                                {...(emailFieldError ? errorInputStyles : {})}
                            />
                            <FieldError id="email-error">{emailFieldError}</FieldError>
                        </FieldWrap>

                        <FieldWrap mb="6px">
                            <FieldLabel htmlFor="password">Password</FieldLabel>
                            <InputGroup>
                                <Input
                                    id="password"
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    autoComplete="current-password"
                                    placeholder="Enter your password"
                                    value={values.password}
                                    onChange={handleFieldChange}
                                    onBlur={handleBlur}
                                    disabled={isBusy}
                                    aria-invalid={!!passwordFieldError}
                                    aria-describedby={passwordFieldError ? 'password-error' : undefined}
                                    pr={{ base: '42px', md: '38px' }}
                                    {...baseInputStyles}
                                    {...(passwordFieldError ? errorInputStyles : {})}
                                />
                                <InputRightElement h={{ base: '42px', md: '38px' }} w={{ base: '42px', md: '38px' }}>
                                    <IconButton
                                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                                        icon={showPassword ? <EyeOffIcon /> : <EyeIcon />}
                                        onClick={togglePassword}
                                        variant="ghost"
                                        size="xs"
                                        color={FAINT}
                                        _hover={{ color: INK, bg: 'transparent' }}
                                        minW="auto"
                                        h="28px"
                                    />
                                </InputRightElement>
                            </InputGroup>
                            <FieldError id="password-error">{passwordFieldError}</FieldError>
                        </FieldWrap>

                        <Flex justify="flex-end" mb="12px">
                            <Link to="/forgot-password">
                                <Text fontSize="11px" color={NAVY} fontWeight="600" _hover={{ textDecoration: 'underline' }}>
                                    Forgot password?
                                </Text>
                            </Link>
                        </Flex>

                        <Box
                            as="button"
                            type="submit"
                            disabled={isBusy}
                            w="full"
                            h={{ base: '46px', md: '40px' }}
                            bg={NAVY}
                            color="white"
                            borderRadius="8px"
                            fontWeight="700"
                            fontSize={{ base: '14px', md: '12.5px' }}
                            fontFamily={FONT}
                            transition="background 0.15s ease, transform 0.1s ease"
                            cursor={isBusy ? 'not-allowed' : 'pointer'}
                            opacity={isBusy ? 0.7 : 1}
                            _hover={isBusy ? undefined : { bg: NAVY_DEEP }}
                            _active={isBusy ? undefined : { transform: 'translateY(1px)' }}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            gap="6px"
                            border="none"
                            aria-busy={isBusy}
                        >
                            {isBusy ? (
                                <>
                                    <Spinner size="xs" color="white" />
                                    <Text>Signing in…</Text>
                                </>
                            ) : (
                                'Sign in'
                            )}
                        </Box>

                        <OrDivider />

                        <Box w="full">
                            <GoogleLoginButton />
                        </Box>

                        <Flex justify="center" mt="12px">
                            <Text fontSize="11px" color={MUTED}>
                                No account?{' '}
                                <Link to="/register">
                                    <Text as="span" color={NAVY} fontWeight="700" _hover={{ textDecoration: 'underline' }}>
                                        Sign up
                                    </Text>
                                </Link>
                            </Text>
                        </Flex>

                        <Text fontSize="10px" color={FAINT} textAlign="center" mt="8px" lineHeight="1.5">
                            By signing in, you agree to our{' '}
                            <Link to="/terms" target="_blank" rel="noopener noreferrer">
                                <Text as="span" color={NAVY} fontWeight="600" _hover={{ textDecoration: 'underline' }}>
                                    Terms of Service
                                </Text>
                            </Link>{' '}
                            and{' '}
                            <Link to="/privacy" target="_blank" rel="noopener noreferrer">
                                <Text as="span" color={NAVY} fontWeight="600" _hover={{ textDecoration: 'underline' }}>
                                    Privacy Policy
                                </Text>
                            </Link>.
                        </Text>
                    </form>
                );
            }}
        </Formik>
    );
};

export default LoginForm;